import { useEffect } from 'react'
import { Skeleton } from 'antd'
import SpreadSheet from './SpreadSheet'
import SaveChangesModal from './SaveChangesModal'
import SpreadSheetContextMenu from './SpreadSheetContextMenu'
import SpreadSheetShortcuts from './SpreadSheetShortcuts'
import { useSpreadSheetData } from './SpreadSheetDataProvider'

SpreadSheetContainer = ({ tableProps, width, height, isClosing, closeTab, type, setIsDirty, tabLabel }) ->

  [{ selectionType }] = useSpreadSheetData()

  <div
    style={{ background: 'transparent', height: '100%'}}
    data-testid="spreadsheet"
  >
    <div style={{ display: 'flex', position: 'relative' }}>
      <SaveChangesModal
        width={width}
        isClosing={isClosing}
        closeTab={closeTab}
        type={type}
        setIsDirty={setIsDirty}
        label={tabLabel}
      />
    </div>
    <SpreadSheetContextMenu>
      <div className="table-view-container">
        <SpreadSheetShortcuts selectionType={selectionType} />
          <SpreadSheet
            width={width}
            height={height}
            cellHeight={40}
          />
      </div>
    </SpreadSheetContextMenu>
  </div>

export default SpreadSheetContainer
